module.exports = __webpack_public_path__ + "static/PANO_20140116_155642-3ac52adaf0a4334e83b51f52725ae344.jpg";